"use client";

import React from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";

const BottomNavbar = React.forwardRef(({ isNavbarVisible }, ref) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to check if the current route matches the link
  const isActive = (path) => location.pathname === path;

  const handleRoommateClick = () => {
    // Navigate to classifieds page with roommate category
    navigate("/classifieds?category=Roommate");
  };

  return (
    <div
      ref={ref}
      className={`fixed bottom-0 left-0 right-0 bg-white border-t z-40 transition-transform duration-300 ${
        isNavbarVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex justify-around items-center h-16 px-1">
        <Link
          to="/home"
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/home") ? "text-purple-600" : "text-gray-500"
          }`}
        >
          <img
            src={"/images/home_icon.svg"}
            alt="Home icon"
            className="w-4 h-4"
          />
          <span className="text-xs mt-1 truncate">Home</span>
        </Link>
        <Link
          to="/discover"
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/discover") ? "text-purple-600" : "text-gray-500"
          }`}
        >
          <img
            src={"/images/search_icon.svg"}
            alt="Discover icon"
            className="w-4 h-4"
          />
          <span className="text-xs mt-1 truncate">Discover</span>
        </Link>
        <Link
          to="/scoops"
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/scoops") ? "text-purple-600" : "text-gray-500"
          }`}
        >
          <img
            src={"/images/scoops_icon.svg"}
            alt="scoops icon"
            className="w-4 h-4"
          />
          <span className="text-xs mt-1 truncate">Scoops</span>
        </Link>
        <Link
          to="/classifieds"
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/classifieds") ? "text-purple-600" : "text-gray-500"
          }`}
        >
          <img
            src={"/images/classfields_icon.svg"}
            alt="classfields icon"
            className="w-4 h-4"
          />
          <span className="text-xs mt-1 truncate">Classifieds</span>
        </Link>
        {/* <button
          onClick={handleRoommateClick}
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/classifieds") &&
            location.search.includes("category=Roommate")
              ? "text-purple-600"
              : "text-gray-500"
          }`}
        >
          <img
            src={"/Images/roommate.png"}
            alt="roommate icon"
            className="w-4 h-4"
          />
          <span className="text-xs mt-1 truncate">Roommate</span>
        </button> */}
        <Link
          to="/makeyaari-onboarding"
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/makeyaari-onboarding")
              ? "text-purple-600"
              : "text-gray-500"
          }`}
        >
          <img
            src={"/images/chat.png"}
            alt="Make Yaari icon"
            className="w-4 h-4"
          />
          <span className="text-xs mt-1 truncate">Yaari</span>
        </Link>
        <Link
          to="/more"
          className={`flex flex-col items-center justify-center min-w-0 flex-1 ${
            isActive("/more") ? "text-purple-600" : "text-gray-500"
          }`}
        >
          <MoreHorizontal className="w-4 h-4" />
          <span className="text-xs mt-1 truncate">More</span>
        </Link>
      </div>
    </div>
  );
});

BottomNavbar.displayName = "BottomNavbar";

export default BottomNavbar;
